import { render } from "./shop-the-look-gallery.vue?vue&type=template&id=39a0a32c"
import script from "./shop-the-look-gallery.vue?vue&type=script&lang=js"
export * from "./shop-the-look-gallery.vue?vue&type=script&lang=js"

import "./shop-the-look-gallery.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__